import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from 'src/service/language-management.service';
import { KeyValues10, LocalService, TriggeredEvent, WorkingRangeType } from 'src/service/local.service';

@Component({
  selector: 'app-working-hours-popup',
  templateUrl: './working-hours-popup.component.html',
  styleUrl: './working-hours-popup.component.scss'
})
export class WorkingHoursPopupComponent {
  @ViewChild('content_working_hours')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  lstSectionConfigKeys: string[] = ["working_hours"];

  @Input() workingRangeType: WorkingRangeType = WorkingRangeType.Business;
  @Input() selectedRange: KeyValues10; @Input() isOnlyTime = false;
  header = '-';

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private languageManagementService: LanguageManagementService) {
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    switch (this.workingRangeType) {
      case WorkingRangeType.Deliverer: {
        this.header = this.localService.languageContent.working_hours.deliverer_header;
      } break;
      case WorkingRangeType.Business: {
        this.header = this.localService.languageContent.working_hours.business_header;
      } break;
      case WorkingRangeType.PickUp: {
        this.header = this.localService.languageContent.working_hours.pickup_header;
      } break;
      case WorkingRangeType.Appoinment: {
        this.header = this.localService.languageContent.working_hours.appointment_header;
      } break;
      default: {
        this.header = this.localService.languageContent.working_hours.header;
      } break;
    }
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.onCloseTrigger({ event: TriggeredEvent.Ok, data: this.selectedRange });
      } break;
    }
  }
  onRangeUpdate(value) {
    this.selectedRange = value;
  }
}
